var map = {
	"./ai/follow.json": 8967,
	"./android/follow.json": 4263,
	"./arvr/follow.json": 5148,
	"./biotech/follow.json": 5084,
	"./blockchain/follow.json": 1027,
	"./devops/follow.json": 1410,
	"./frontend/follow.json": 2062,
	"./ios/follow.json": 6026,
	"./pm/follow.json": 3869,
	"./qa/follow.json": 3859,
	"./quantum-computing/follow.json": 9769,
	"./web/follow.json": 482
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4702;
module.exports = webpackAsyncContext;